exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#app-layout div.show-filters {\n  height: 90px;\n  width: 23px;\n  position: absolute;\n  left: 0px;\n  background-color: white;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  line-height: 90px;\n  top: 50%;\n  cursor: pointer;\n  margin-top: -45px;\n  z-index: 9;\n  text-align: center;\n}\ndiv#app-layout .fade-enter-active, div#app-layout .fade-leave-active {\n  transition: opacity 0.2s;\n}\ndiv#app-layout .fade-enter, div#app-layout .fade-leave-to {\n  opacity: 0;\n}", ""]);

// exports
